module.exports = __webpack_public_path__ + "1b8f33bc066097bd23b24ceb6a1d07d1.svg";